import type { QuickLinkCreatorReducerType } from 'client/js/main/reducers/QuickLinkCreatorReducer/types/QuickLinkCreatorReducerType';
import { QuickLinkCreatorService } from 'client/js/main/services/QuickLinkCreatorService/QuickLinkCreatorService';
import type { QrCodeLinkCreatorState } from 'client/js/redux/domains/QrCodeLinkCreator/types';
import type { IQrCodeLinkCreate, IQrCodeLinkUpdate, LinkifierQrCodeSettings } from '../../../../../shared/types';

export class QrCodeLinkCreatorService extends QuickLinkCreatorService {
  private static getQrCodeTitle = (qrCodeLinkRawData: QrCodeLinkCreatorState): string => {
    return qrCodeLinkRawData.title;
  };

  private static getQrCodeCustomization = (qrCodeLinkRawData: QrCodeLinkCreatorState): LinkifierQrCodeSettings => {
    return {
      ...qrCodeLinkRawData.qrCodeCustomization,
      qr_settings_id: qrCodeLinkRawData.qrSettingsId,
    };
  };

  public static getQrCodeLinkPayload = (
    qrCodeLinkRawData: QrCodeLinkCreatorState
  ): IQrCodeLinkCreate | IQrCodeLinkUpdate => {
    const qrCodeLinkAsQuickLink = {
      ...qrCodeLinkRawData,
      webOnlyLink: qrCodeLinkRawData.isWebOnly,
    } as unknown as QuickLinkCreatorReducerType;

    return {
      id: qrCodeLinkRawData.id,
      title: this.getQrCodeTitle(qrCodeLinkRawData),
      archived: false,
      analyticsTags: this.getAnalyticsTags(qrCodeLinkAsQuickLink),
      redirects: this.getRedirects(qrCodeLinkAsQuickLink),
      linkData: this.getLinkData(qrCodeLinkAsQuickLink),
      qrCode: this.getQrCodeCustomization(qrCodeLinkRawData),
    };
  };
}
